/* eslint-disable */
import Vue from 'vue'
import _ from 'underscore'
import Vuex from 'vuex'
import payment from './payment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {

  },
  modules: {
    payment
  },
  actions: {

  }
})
